<template>
    <div>
        <div class="col-md-10 mx-auto">
            <form-summary-grid :formToRegisterEntityId="id">

            </form-summary-grid>
        </div>
    </div>
</template>

<script>
    import FormSummaryGrid from "@/components/forms/FormSummaryGrid";

    export default {
        components: {
            FormSummaryGrid
        },
        props: {
            id: {
                type: [Number, String],
                required: true
            },
            returnUrl: {
                type: String
            }
        },
        data() {
            return {
            }
        },
        computed: {
            formToRegisterEntityId() {
                if (typeof this.id === 'number') {
                    return this.id;
                }

                return Number(this.id.replaceAll(' ', ''));
            }
        },
        methods: {
            redirectToList() {
                if (this.returnUrl) {
                    this.$router.push({ path: this.returnUrl });
                } else {
                    this.$router.push({ path: '/forms/active' });
                }
            }
        }
    }
</script>
